import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import logo from './Images/logo24.png';
import logoTivigil from './Images/logo_tivigil.png';
import teamPhoto from './Images/Team/team-photo.jpg.jpg';
import arielleImg from './Images/Team/arielle.jpg';
import aureliaImg from './Images/Team/Aurélia.jpg';
import flavienImg from './Images/Team/flavien.jpg';
import shanaelleImg from './Images/Team/shanaëlle.jpg';
import tomImg from './Images/Team/tom.jpg';
import youssoufImg from './Images/Team/youssouf.jpg';
import aleaCarte from './Images/Alea_mouvement_de_terrain_CARTE.jpg';

interface TeamMember {
  id: number;
  name: string;
  role: string;
  bio: string;
  image: string;
}

function App() {
  const [showProjectPage, setShowProjectPage] = useState(false);
  const [showTeamCards, setShowTeamCards] = useState(false);
  const teamSectionRef = useRef<HTMLElement>(null);

  // Bloquer le scroll de la page principale quand la popup est ouverte
  useEffect(() => {
    if (showProjectPage) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [showProjectPage]);

  const handleViewChange = (showCards: boolean) => {
    const currentScrollY = window.scrollY;
    setShowTeamCards(showCards);

    // Restore scroll position after state update
    requestAnimationFrame(() => {
      window.scrollTo({
        top: currentScrollY,
        behavior: 'auto'
      });
    });
  };

  const teamMembers: TeamMember[] = [
    {
      id: 1,
      name: "Tom Turpin",
      role: "Chef de Projet",
      bio: "",
      image: tomImg
    },
    {
      id: 2,
      name: "Flavien Maillot",
      role: "Terminale spé math et SI",
      bio: "",
      image: flavienImg
    },
    {
      id: 3,
      name: "Arielle Macaire-Noah",
      role: "1ère année CPES",
      bio: "",
      image: arielleImg
    },
    {
      id: 4,
      name: "Aurélia Plante Latchoumanin",
      role: "1ère année CPES",
      bio: "",
      image: aureliaImg
    },
    {
      id: 5,
      name: "Adam Boto Youssouf",
      role: "Membre de l'équipe",
      bio: "",
      image: youssoufImg
    },
    {
      id: 6,
      name: "Shanaëlle Sangelle",
      role: "3ème",
      bio: "",
      image: shanaelleImg
    }
  ];

  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <img src={logo} alt="24h Innovation Réunion" className="logo-24h" />
          <div className="hero-main">
            <img src={logoTivigil} alt="Logo Tivigil" className="logo-tivigil" />
            <div className="hero-text">
              <h1 className="hero-title">Ti Vigil</h1>
              <p className="hero-subtitle">Système de Détection de Glissements de Terrain</p>
              <div className="hero-description">
                <p>Une solution innovante pour prévenir les catastrophes naturelles et protéger les vies humaines à La Réunion</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <h2 className="section-title">À propos des 24 Heures de l'Innovation</h2>
          <p className="about-text">
            Des équipes composées d'étudiants, de lycéens et de collégiens, issus d'établissements de tout le territoire,
            ont 24h pour développer des solutions innovantes en réponse à des sujets proposés par des entreprises, des laboratoires,
            des créateurs locaux… Les participants présentent ensuite leurs résultats en 3min devant un jury qui désigne les équipes gagnantes.
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section" ref={teamSectionRef}>
        <div className="container">
          <h2 className="section-title">Notre Équipe</h2>

          <div className="team-view-container">
            {!showTeamCards ? (
              <div className="team-intro">
                <div className="team-photo-container">
                  <img src={teamPhoto} alt="Équipe Ti Vigil" className="team-group-photo" />
                </div>
                <button className="team-nav-arrow team-nav-arrow-right" onClick={() => handleViewChange(true)}>
                  →
                </button>
              </div>
            ) : (
              <>
                <button className="team-nav-arrow team-nav-arrow-left" onClick={() => handleViewChange(false)}>
                  ←
                </button>
                <div className="team-grid">
                  {teamMembers.map(member => (
                    <div key={member.id} className="team-card">
                      <img src={member.image} alt={member.name} className="team-image" />
                      <h3 className="team-name">{member.name}</h3>
                      <p className="team-role">{member.role}</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Project Section */}
      <section className="project-section">
        <div className="container">
          <h2 className="section-title">Notre Projet d'Innovation</h2>
          <div className="project-card">
            <h3 className="project-title">Ti Vigil</h3>
            <p className="project-subtitle">Système intelligent de détection et d'alerte de glissements de terrain</p>

            <div className="project-summary">
              <p>
                Ti Vigil est une solution complète de prévention des glissements de terrain à La Réunion,
                combinant une application mobile interactive et des bornes d'alerte intelligentes pour protéger les populations.
              </p>
            </div>

            <div className="project-parts">
              <div className="project-part">
                <h4>📱 L'Application Mobile</h4>
                <ul className="project-list">
                  <li><strong>Sensibilisation :</strong> Tutoriel de l'application et numéros d'urgence</li>
                  <li><strong>Signalement d'alerte :</strong> Envoi de signalements (texte, vocal, image, géolocalisation) analysés par IA avec système de récompenses partenaires</li>
                  <li><strong>Base de données :</strong> Consultation des alertes effectuées par la communauté</li>
                  <li><strong>Carte interactive :</strong> Visualisation des lieux à risque et des bornes d'alerte</li>
                </ul>
              </div>

              <div className="project-part">
                <h4>🚨 Les Bornes d'Alerte</h4>
                <p className="borne-description">
                  Bornes cylindriques de 1m50 de hauteur pour 50cm de diamètre en PEHD, équipées de :
                </p>
                <ul className="project-list">
                  <li><strong>Haut-parleur :</strong> Signal d'alarme sonore en cas de danger</li>
                  <li><strong>Écran tactile 11 pouces :</strong> Interface d'alerte accessible à tous</li>
                  <li><strong>Antenne radio fréquence :</strong> Communication en temps réel</li>
                  <li><strong>Sismomètres :</strong> Capteurs de détection (technologie Cité du Volcan)</li>
                </ul>
              </div>
            </div>

            <button className="btn btn-primary" onClick={() => setShowProjectPage(true)}>
              En savoir plus
            </button>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section">
        <div className="container">
          <h2 className="section-title">Programme de l'événement</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-time">
                <span className="time-day">Jeudi</span>
                <span className="time-hour">10h30</span>
              </div>
              <div className="timeline-content">
                <h4>Accueil & Présentation</h4>
                <p>Accueil des participants et présentation du défi</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-time">
                <span className="time-day">Jeudi</span>
                <span className="time-hour">11h00</span>
              </div>
              <div className="timeline-content">
                <h4>Brainstorming</h4>
                <p>Idéation et définition de la solution</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-time">
                <span className="time-day">Jeudi</span>
                <span className="time-hour">13h00</span>
              </div>
              <div className="timeline-content">
                <h4>Conception</h4>
                <p>Début de la conception de la solution</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-time">
                <span className="time-day">Vendredi</span>
                <span className="time-hour">08h00</span>
              </div>
              <div className="timeline-content">
                <h4>Sprint Final</h4>
                <p>Finalisation et préparation du pitch</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-time">
                <span className="time-day">Vendredi</span>
                <span className="time-hour">12h00</span>
              </div>
              <div className="timeline-content">
                <h4>Présentations & Jury</h4>
                <p>Pitch des projets et délibération du jury</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Detail Page */}
      {showProjectPage && (
        <div className="project-page-overlay">
          <div className="project-page">
            <button className="project-page-close" onClick={() => setShowProjectPage(false)}>
              ← Retour
            </button>

            <div className="project-page-content">
              <h1 className="project-page-title">Ti Vigil</h1>
              <p className="project-page-subtitle">Système intelligent de détection de glissements de terrain</p>

              <section className="project-page-section">
                <h2>Vision du projet</h2>
                <p>
                  À La Réunion, l'île intense, nous faisons face à des risques naturels importants : relief escarpé,
                  fortes précipitations et sols vulnérables créent des conditions propices aux glissements de terrain.
                  Ti vigil est né de la volonté de protéger les populations exposées en créant un système d'alerte précoce
                  intelligent et accessible à tous.
                </p>
                <p>
                  Notre solution vise à sauver des vies en détectant les signes précurseurs de glissements de terrain
                  grâce à des capteurs IoT, l'intelligence artificielle et une analyse en temps réel. Nous transformons
                  les données environnementales en alertes actionnables pour les autorités et les citoyens.
                </p>
              </section>

              <section className="project-page-section">
                <h2>Fonctionnalités principales</h2>
                <div className="feature-list">
                  <div className="feature-detail">
                    <h3>🛰️ Réseau de capteurs IoT</h3>
                    <p>
                      Un réseau de capteurs connectés déployés sur les zones à risque mesure en continu les mouvements
                      du sol, l'humidité, les vibrations et autres indicateurs critiques. Ces données sont transmises
                      en temps réel vers notre plateforme cloud pour analyse instantanée.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>🤖 Intelligence Artificielle Prédictive</h3>
                    <p>
                      Notre système IA analyse les données historiques et en temps réel pour identifier les patterns
                      précurseurs de glissements de terrain. Machine learning et deep learning permettent d'améliorer
                      continuellement la précision des prédictions et de réduire les fausses alertes.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>⚠️ Système d'Alerte Multi-Canal</h3>
                    <p>
                      En cas de risque détecté, des alertes sont envoyées instantanément via SMS, notifications push,
                      sirènes et panneaux d'affichage. Les autorités locales et services d'urgence sont notifiés en
                      priorité pour permettre une évacuation rapide si nécessaire.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>📊 Tableau de Bord Temps Réel</h3>
                    <p>
                      Interface web et mobile permettant aux autorités de visualiser l'état de tous les capteurs,
                      consulter l'historique des alertes, et accéder à des cartes de risques actualisées. Données
                      historiques et statistiques pour une meilleure planification urbaine.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>🗺️ Cartographie des Zones à Risque</h3>
                    <p>
                      Cartographie interactive montrant les zones surveillées, le niveau de risque actuel, et les
                      zones d'évacuation. Intégration avec les données géologiques et météorologiques pour une
                      évaluation complète des risques.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>📱 Application Citoyenne</h3>
                    <p>
                      Application mobile permettant aux citoyens de recevoir des alertes géolocalisées, signaler
                      des observations terrain (fissures, chutes de pierres), et accéder aux plans d'évacuation.
                      Interface simple et accessible à tous.
                    </p>
                  </div>
                </div>
              </section>

              <section className="project-page-section">
                <h2>🎯 IA d'Inspection Géologique Autonome</h2>
                <p className="ai-intro">
                  Solution d'analyse critique et autonome des images de terrain (fissures, érosion) pour
                  déterminer le niveau de gravité et déclencher une alerte d'urgence ou une intervention auprès de
                  l'autorité compétente, sans intervention humaine.
                </p>

                <h3 className="subsection-title">Fonctionnalités de l'IA</h3>
                <div className="feature-list">
                  <div className="feature-detail">
                    <h3>🔍 Détection et Localisation</h3>
                    <p>
                      Permet d'identifier des objets d'intérêt tels que fissures, érosions ou glissements, et de tracer
                      leur position exacte dans une image. Cela confirme la présence effective d'un défaut.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>📏 Mesure et Quantification</h3>
                    <p>
                      Automatisation de la mesure des dimensions critiques du défaut (longueur, largeur, profondeur estimée).
                      Ces valeurs servent à évaluer la gravité du problème.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>🤖 Classification de la Gravité</h3>
                    <p>
                      Classe le défaut selon différents niveaux de sévérité (Mineur, Modéré, Critique), sur la base de
                      critères définis par des experts. L'IA détermine le niveau de menace sans intervention humaine directe.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>⚙️ Moteur de Décision</h3>
                    <p>
                      Traduit le niveau de gravité en actions concrètes (déclencher une alerte d'urgence ou
                      simplement journaliser l'événement). Il décide de la marche à suivre et de qui prévenir.
                    </p>
                  </div>
                  <div className="feature-detail">
                    <h3>📨 Génération d'Alerte Automatique</h3>
                    <p>
                      Envoie automatiquement des notifications (email, SMS, notification push) aux autorités et services
                      d'urgence concernés, avec le niveau de gravité et les détails de localisation.
                    </p>
                  </div>
                </div>

                <h3 className="subsection-title">Technologies & Architecture</h3>
                <div className="tech-details">
                  <div className="tech-detail-item">
                    <h3>Type de Modèle</h3>
                    <p><strong>Deep Learning</strong> (Apprentissage Profond)</p>
                  </div>
                  <div className="tech-detail-item">
                    <h3>Architecture de Base</h3>
                    <p><strong>Réseaux de Neurones Convolutifs (CNN)</strong></p>
                    <p>Basés sur des architectures de Segmentation d'Instance (ex. : Mask R-CNN) pour localiser et
                    mesurer précisément les défauts.</p>
                  </div>
                  <div className="tech-detail-item">
                    <h3>Composants</h3>
                    <p><strong>Vision par Ordinateur</strong> (Computer Vision) pour l'analyse visuelle</p>
                    <p><strong>Moteur de Logique</strong> (Rule-Based System) pour la prise de décision</p>
                  </div>
                  <div className="tech-detail-item">
                    <h3>Plateforme d'Hébergement</h3>
                    <p><strong>Services Cloud</strong> (AWS SageMaker, Google Vertex AI, Azure ML)</p>
                    <p>Nécessitant des GPU (Unités de Traitement Graphique) pour l'inférence rapide</p>
                  </div>
                  <div className="tech-detail-item">
                    <h3>API</h3>
                    <p><strong>API REST</strong> pour la soumission d'images et la réception des résultats</p>
                  </div>
                </div>
              </section>

              <section className="project-page-section map-section">
                <h2>🗺️ Carte des Aléas de Mouvements de Terrain</h2>
                <p>
                  Visualisation des zones à risque de mouvements de terrain à La Réunion selon le niveau d'aléa.
                  Cette cartographie permet d'identifier les secteurs nécessitant une surveillance prioritaire.
                </p>
                <div className="large-map-container">
                  <img src={aleaCarte} alt="Carte Aléa Mouvement de Terrain La Réunion" className="large-risk-map" />
                  <div className="map-legend">
                    <p className="map-caption">Carte officielle des aléas de mouvements de terrain à La Réunion</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 - 24 Heures de l'Innovation La Réunion</p>
          <p className="footer-tagline">Innovation • Collaboration • Impact</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
